import { CALL_ABLE_PORTAL_API } from '../../middleware/authHeaders'
import { ABLE_PORTAL_API_ROOT } from '../../config/api'
import { errorNotification, successNotification } from '../application/notifications'

// TYPES & ACTIONS
export const ABLE_GET_ACCOUNTS_PAYABLE_REQUEST = 'GET_ACCOUNTS_PAYABLE_REQUEST'
export const ABLE_GET_ACCOUNTS_PAYABLE_SUCCESS = 'GET_ACCOUNTS_PAYABLE_SUCCESS'
export const ABLE_GET_ACCOUNTS_PAYABLE_FAILURE = 'GET_ACCOUNTS_PAYABLE_FAILURE'
export const getAccountsPayable = (source, showUatCharities) => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'GET',
      endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-payable?source=${source}&showUatCharities=${showUatCharities}`,
      types: [
        ABLE_GET_ACCOUNTS_PAYABLE_REQUEST,
        ABLE_GET_ACCOUNTS_PAYABLE_SUCCESS,
        ABLE_GET_ACCOUNTS_PAYABLE_FAILURE,
      ],
    },
  })
}

export const ABLE_GET_ACCOUNTS_RECEIVABLE_REQUEST = 'GET_ACCOUNTS_RECEIVABLE_REQUEST'
export const ABLE_GET_ACCOUNTS_RECEIVABLE_SUCCESS = 'GET_ACCOUNTS_RECEIVABLE_SUCCESS'
export const ABLE_GET_ACCOUNTS_RECEIVABLE_FAILURE = 'GET_ACCOUNTS_RECEIVABLE_FAILURE'
export const getAccountsReceivable = () => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'GET',
      endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-receivable`,
      types: [
        ABLE_GET_ACCOUNTS_RECEIVABLE_REQUEST,
        ABLE_GET_ACCOUNTS_RECEIVABLE_SUCCESS,
        ABLE_GET_ACCOUNTS_RECEIVABLE_FAILURE,
      ],
    },
  })
}

export const ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_REQUEST = 'GET_ACCOUNTS_RECEIVABLE_CSV_REQUEST'
export const ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_SUCCESS = 'GET_ACCOUNTS_RECEIVABLE_CSV_SUCCESS'
export const ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_FAILURE = 'GET_ACCOUNTS_RECEIVABLE_CSV_FAILURE'
export const getAccountsReceivableCsv = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({
      [CALL_ABLE_PORTAL_API]: {
        method: 'GET',
        endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-receivable/csv`,
        types: [
          ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_REQUEST,
          {
            type: ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_SUCCESS,
            meta: (action, state, res) => {
              res.text().then(data => resolve(data))
            },
          },
          {
            type: ABLE_GET_ACCOUNTS_RECEIVABLE_CSV_FAILURE,
            meta: (action, state, error) => {
              reject(error)
            },
          },
        ],
      },
    })
  })
}

export const ABLE_GET_ACCOUNTS_PAYABLE_CSV_REQUEST = 'GET_ACCOUNTS_PAYABLE_CSV_REQUEST'
export const ABLE_GET_ACCOUNTS_PAYABLE_CSV_SUCCESS = 'GET_ACCOUNTS_PAYABLE_CSV_SUCCESS'
export const ABLE_GET_ACCOUNTS_PAYABLE_CSV_FAILURE = 'GET_ACCOUNTS_PAYABLE_CSV_FAILURE'
export const getAccountsPayableCsv = source => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({
      [CALL_ABLE_PORTAL_API]: {
        method: 'GET',
        endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-payable/csv?source=${source}`,
        types: [
          ABLE_GET_ACCOUNTS_PAYABLE_CSV_REQUEST,
          {
            type: ABLE_GET_ACCOUNTS_PAYABLE_CSV_SUCCESS,
            meta: (action, state, res) => {
              res.text().then(data => resolve(data))
            },
          },
          {
            type: ABLE_GET_ACCOUNTS_PAYABLE_CSV_FAILURE,
            meta: (action, state, error) => {
              reject(error)
            },
          },
        ],
      },
    })
  })
}

export const ABLE_POST_ACCOUNTS_PAYABLE_REQUEST = 'POST_ACCOUNTS_PAYABLE_REQUEST'
export const ABLE_POST_ACCOUNTS_PAYABLE_SUCCESS = 'POST_ACCOUNTS_PAYABLE_SUCCESS'
export const ABLE_POST_ACCOUNTS_PAYABLE_FAILURE = 'POST_ACCOUNTS_PAYABLE_FAILURE'
export const postAccountsPayable = payload => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'POST',
      endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-payable`,
      body: JSON.stringify(payload),
      types: [
        ABLE_POST_ACCOUNTS_PAYABLE_REQUEST,
        ABLE_POST_ACCOUNTS_PAYABLE_SUCCESS,
        ABLE_POST_ACCOUNTS_PAYABLE_FAILURE,
      ],
    },
  }).then(response => {
    if (
      (!response?.payload?.error || response?.payload?.status !== 'FAILED') &&
      response?.type === ABLE_POST_ACCOUNTS_PAYABLE_SUCCESS
    ) {
      dispatch(
        successNotification({
          body: `Request was sent. You will need to refresh the page.`,
          dismissInSeconds: 5,
        })
      )
    }
    if (response?.payload?.error || response?.type === ABLE_POST_ACCOUNTS_PAYABLE_FAILURE) {
      dispatch(
        errorNotification({
          body: `Unable to send funds`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const ABLE_POST_ACCOUNTS_RECEIVABLE_REQUEST = 'POST_ACCOUNTS_RECEIVABLE_REQUEST'
export const ABLE_POST_ACCOUNTS_RECEIVABLE_SUCCESS = 'POST_ACCOUNTS_RECEIVABLE_SUCCESS'
export const ABLE_POST_ACCOUNTS_RECEIVABLE_FAILURE = 'POST_ACCOUNTS_RECEIVABLE_FAILURE'
export const postAccountsReceivable = payload => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'POST',
      endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-receivable`,
      body: JSON.stringify(payload),
      types: [
        ABLE_POST_ACCOUNTS_RECEIVABLE_REQUEST,
        ABLE_POST_ACCOUNTS_RECEIVABLE_SUCCESS,
        ABLE_POST_ACCOUNTS_RECEIVABLE_FAILURE,
      ],
    },
  }).then(response => {
    if (!response?.payload.error && response?.type === ABLE_POST_ACCOUNTS_RECEIVABLE_SUCCESS) {
      dispatch(
        successNotification({
          body: `Successfully recorded invoice as paid`,
          dismissInSeconds: 5,
        })
      )
      dispatch(getAccountsReceivable())
    }
    if (response?.payload.error || response?.type === ABLE_POST_ACCOUNTS_RECEIVABLE_FAILURE) {
      dispatch(
        errorNotification({
          body: `Unable to record invoice as paid`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const ABLE_POST_INVOICE_REQUEST = 'POST_INVOICE_REQUEST'
export const ABLE_POST_INVOICE_SUCCESS = 'POST_INVOICE_SUCCESS'
export const ABLE_POST_INVOICE_FAILURE = 'POST_INVOICE_FAILURE'
export const postInvoice = payload => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'POST',
      endpoint: `${ABLE_PORTAL_API_ROOT}/invoice`,
      body: JSON.stringify(payload),
      types: [ABLE_POST_INVOICE_REQUEST, ABLE_POST_INVOICE_SUCCESS, ABLE_POST_INVOICE_FAILURE],
    },
  }).then(response => {
    if (!response?.payload?.errors.length && response?.type === ABLE_POST_INVOICE_SUCCESS) {
      dispatch(
        successNotification({
          body: `Successfully created invoice`,
          dismissInSeconds: 5,
        })
      )
      dispatch(getAccountsReceivable())
    }
    if (response?.payload?.errors.length > 0 || response?.type === ABLE_POST_INVOICE_FAILURE) {
      dispatch(
        errorNotification({
          body: `Unable to create an invoice`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const ABLE_GET_NPO_DETAILS_REQUEST = 'ABLE_GET_NPO_DETAILS_REQUEST'
export const ABLE_GET_NPO_DETAILS_SUCCESS = 'ABLE_GET_NPO_DETAILS_SUCCESS'
export const ABLE_GET_NPO_DETAILS_FAILURE = 'ABLE_GET_NPO_DETAILS_FAILURE'
export const getNpoDetails = id => dispatch => {
  dispatch({
    [CALL_ABLE_PORTAL_API]: {
      method: 'GET',
      endpoint: `${ABLE_PORTAL_API_ROOT}/accounts-payable/${id}`,
      types: [
        ABLE_GET_NPO_DETAILS_REQUEST,
        ABLE_GET_NPO_DETAILS_SUCCESS,
        ABLE_GET_NPO_DETAILS_FAILURE,
      ],
    },
  })
}

export const ABLE_SET_CURRENT_ORG = 'ABLE_SET_CURRENT_ORG'

export const setOrgDetails = orgDetails => ({
  type: ABLE_SET_CURRENT_ORG,
  payload: orgDetails,
})

export const CLEAR_ACCOUNTS_PAYABLE_DETAILS = 'CLEAR_ACCOUNTS_PAYABLE_DETAILS'

export const clearAccountsPayableDetails = () => ({
  type: CLEAR_ACCOUNTS_PAYABLE_DETAILS,
})

// SELECTORS
export const selectLedgerSlice = state => state.ablePortal.ledger

export const selectOrgDetails = state => selectLedgerSlice(state).orgDetails

// STATE
const INITIAL_STATE = {
  accountsPayable: null,
  accountsReceivable: null,
  orgDetails: {},
}

// REDUCERS
const ledger = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [ABLE_GET_ACCOUNTS_PAYABLE_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      accountsPayable: newPayload,
    }),
    [CLEAR_ACCOUNTS_PAYABLE_DETAILS]: currentState => ({
      ...currentState,
      accountsPayable: null,
    }),
    [ABLE_GET_ACCOUNTS_RECEIVABLE_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      accountsReceivable: newPayload,
    }),
    [ABLE_SET_CURRENT_ORG]: (currentState, newPayload) => ({
      ...currentState,
      orgDetails: newPayload,
    }),
    [ABLE_GET_NPO_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      npoDetails: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default ledger
